import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'reactstrap';
import Flex from '../common/Flex';

import { withTranslation, WithTranslation } from 'react-i18next';

class CienytechNavbarVerticalMenuItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Flex align="center">
                {this.props.route.icon && (
                    <span className="nav-link-icon">
                        <FontAwesomeIcon icon={this.props.route.icon} />
                    </span>
                )}
                <span className="nav-link-text">{this.props.t(this.props.route.name)}</span>
                {!!this.props.route.badge && (
                    <Badge color={this.props.route.badge.color || 'soft-success'} pill className="ml-2">
                        {this.props.route.badge.text}
                    </Badge>
                )}
            </Flex>
        );
    }
}

export default withTranslation()(CienytechNavbarVerticalMenuItem);